import type { ReactNode } from "react";
import { DateRange } from "@/components/data";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import type { PropostaResumoPeriodo } from "@/types/finance";

function ContagemComLista({ rotulo, children }: { rotulo: string; children: ReactNode }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0} className="underline decoration-dotted underline-offset-2">
          {rotulo}
        </span>
      </TooltipTrigger>
      {/* The tooltip is portaled, but its clicks still bubble to the row, which would open the proposal. */}
      <TooltipContent onClick={(event) => event.stopPropagation()} className="max-h-72 overflow-y-auto">
        <ul className="space-y-1">{children}</ul>
      </TooltipContent>
    </Tooltip>
  );
}

function Periodo({ periodo }: { periodo: PropostaResumoPeriodo }) {
  if (!periodo.data_inicio && !periodo.data_conclusao) return <>Sem datas</>;
  return <DateRange start={periodo.data_inicio} end={periodo.data_conclusao} />;
}

export function FreelancersEPeriodos({ periodos }: { periodos: PropostaResumoPeriodo[] }) {
  if (periodos.length === 0) return <span className="text-muted-foreground">-</span>;

  const nomesPorFreelancer = new Map(periodos.map((periodo) => [periodo.freelancer_id, periodo.freelancer_nome]));
  const freelancers = [...nomesPorFreelancer.entries()];
  const variosFreelancers = freelancers.length > 1;

  return (
    <TooltipProvider delayDuration={150}>
      <div className="space-y-0.5">
        <div>
          {variosFreelancers ? (
            <ContagemComLista rotulo={`${freelancers.length} freelancers`}>
              {freelancers.map(([id, nome]) => (
                <li key={id}>{nome}</li>
              ))}
            </ContagemComLista>
          ) : (
            freelancers[0][1]
          )}
        </div>
        <div className="text-xs text-muted-foreground">
          {periodos.length > 1 ? (
            <ContagemComLista rotulo={`${periodos.length} períodos`}>
              {periodos.map((periodo, indice) => (
                <li key={indice} className="whitespace-nowrap">
                  {variosFreelancers && <span className="font-medium">{periodo.freelancer_nome}: </span>}
                  <Periodo periodo={periodo} />
                </li>
              ))}
            </ContagemComLista>
          ) : (
            <Periodo periodo={periodos[0]} />
          )}
        </div>
      </div>
    </TooltipProvider>
  );
}
